// ** React Imports
import { ReactNode } from 'react'

// ** Component Imports
import { AbilityContext } from './Can'

// ** Types
import { NavLink } from '../../../@core/layouts/types'
import { defaultACLObj } from '../../../../configs/acl'
import { useAbility } from '@casl/react'

interface Props {
  navLink?: NavLink
  children: ReactNode
}

const CanViewNavLink = (props: Props) => {
  // ** Props
  const { children, navLink } = props

  const ability = useAbility(AbilityContext)
  const aclAbilities = navLink?.acl ?? defaultACLObj;

  return ability && ability.can(aclAbilities.action, aclAbilities.subject) ? <>{children}</> : null
}

export default CanViewNavLink
